import { FC, useEffect, useState } from "react";

import AddCasePatientInformation from "../addCase/addCasePatientInformation";
import AddCasePatientAddress from "../addCase/addCasePatientAddress";
import AddCasePatientInsurances from "../addCase/addCasePatientInsurances";
import ZilrettaOnStepTwo from "../addCase/zilrettaOnStepTwo";

import { CaseStepTwoProps } from "./types";
import IOveraOnStepTwo from "../addCase/ioveraOnStepTwo";



const CaseStepTwo: FC<CaseStepTwoProps> = ({ control, isVisible, getValues, watch, setValue, trigger ,clearErrors}): JSX.Element => {
  const [prevDrugName, updateDrugName] = useState(getValues("prescription_attributes.drug_name"))

  const drug_name = watch("prescription_attributes.drug_name");
  const iAm = watch("doctor_attributes.i_am");
  const doctorId = watch("doctor_attributes.global_doctor_id");
  const selectedDrug = watch("prescription_attributes.drug_name");
  const treatingDoctorId = watch("doctor_attributes.treating_doctor_id");
  const referringDoctorId = watch("doctor_attributes.referring_doctor_id");

  useEffect(() => {
    if (drug_name && drug_name !== prevDrugName) {
      updateDrugName(drug_name)

      if (drug_name === "iovera°") {
        setValue("doctor_attributes", {
          i_am: "",
          treating_practice_id: 0, treating_doctor_id: 0,
          referring_practice_id: 0, referring_doctor_id: 0,
        })
      } else {
        setValue("doctor_attributes", {
          practice_id: 0, global_doctor_id: 0,
        })
      }
    }
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [drug_name])

  return (
    <div className={`${!isVisible ? 'd-none' : ''}`}>
      <div className="card mb-3">
        {selectedDrug === "iovera°" ? (
          <IOveraOnStepTwo control={control} getValues={getValues} setValue={setValue} trigger={trigger} watch={watch} />
        ) : (
          <ZilrettaOnStepTwo control={control} getValues={getValues} setValue={setValue} trigger={trigger} watch={watch} />
        )}
      </div>

      {doctorId || (["Referring Facility", "Referring Provider"].includes(iAm) ? (treatingDoctorId && referringDoctorId) : treatingDoctorId) ? (
        <>
          <AddCasePatientInformation control={control} watch={watch} getValues={getValues} setValue={setValue} />
          <AddCasePatientAddress control={control} watch={watch} getValues={getValues} setValue={setValue} />
          <AddCasePatientInsurances control={control} watch={watch} getValues={getValues} setValue={setValue} />
        </>
      ) : null}
    </div>
  );
};

export default CaseStepTwo;
